import rootPackageJson from '../../../package.json';

const codeBaseVersion = ['production', 'test', 'stage'].includes(ENVIRONMENT)
  ? rootPackageJson.version
  : `${ENVIRONMENT}@${GIT_COMMIT_HASH?.slice(0, 7) ?? 'working-tree'}`;

export default codeBaseVersion;
